
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1399","transform":"translate(-7367 -1178)"}},[_c('rect',{attrs:{"data-name":"사각형 2129","width":"14","height":"20","rx":"1","transform":"translate(7367 1178)","fill":"#f36628"}}),_c('rect',{attrs:{"data-name":"사각형 2130","width":"3","height":"3","rx":"1","transform":"translate(7370 1181)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"사각형 2131","width":"3","height":"3","rx":"1","transform":"translate(7375 1181)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"사각형 2132","width":"3","height":"3","rx":"1","transform":"translate(7370 1186)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"사각형 2133","width":"3","height":"3","rx":"1","transform":"translate(7375 1186)","fill":"#fff"}}),_c('path',{attrs:{"data-name":"사각형 2134","d":"M7373 1193h2a1 1 0 011 1v4h-4v-4a1 1 0 011-1z","fill":"#fff"}})])])
          )
        }
      }
    